import { Component } from '@angular/core';

@Component({
  selector: 'no-content',
  // template: `
  //   <div>
  //     <div class="unauthorized">401: Sorry, it seems your don't have authorization to access this page</div>
  //   </div>
  // `
  template: `
  <div class="wrapper row2">
  <div id="container" class="clear">
    <section id="fof" class="clear">
      <a class="go-back" href="javascript:history.go(-1)">Back<br>&laquo;</a>
      <div class="positioned">
        <h1>401 Unauthorized</h1>
        <!--<p>For Some Reason The Page You Requested Could Not Be Found On Our Server</p>-->
        <p>Apologies, it seems you don't have access to this feature. If you think otherwise, please contact support at scrimssupport@fox.com</p>
      </div>
      <a class="go-home" href="#">Home<br>&raquo;</a>
    </section>
  </div>
</div>
  `
})
export class UnAuthorizeComponent {

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/helper-components/un-authorize.component.ts